var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.079 16.312a5.079 5.079 0 0 1 0-10.157h8.543l5-2.038A1.75 1.75 0 0 1 23 5.75v10.966a1.75 1.75 0 0 1-2.378 1.634l-5-2.038h-2.887l1.625 3.262a.467.467 0 0 1-.418.675h-2.88a.467.467 0 0 1-.418-.259l-1.833-3.678H7.08z",
    fill: "#FFE14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepost);
export default __webpack_public_path__ + "static/media/repost.0a572baa92c666958f58057f16016064.svg";
export { ForwardRef as ReactComponent };